export default __webpack_public_path__ + "static/media/approach.25e5a89c.svg";